import React, { useState, useEffect, useMemo } from 'react';
import '../styles/components/FilterSidebar.scss';

const currencyFormatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  minimumFractionDigits: 0,
});

const FilterSidebar = ({ initial, onChange }) => {
  const [minPrice, setMinPrice] = useState(initial.minPrice || 0);
  const [maxPrice, setMaxPrice] = useState(initial.maxPrice || 100000);
  const [options, setOptions] = useState([]);       // lista dinámica de variaciones
  const [selected, setSelected] = useState(initial.variations || []);

  const rangeMin = 0;
  const rangeMax = 100000;

  useEffect(() => {
    const uniq = new Set();
    (initial.allProducts || []).forEach((p) => {
      const keys = Array.isArray(p.variations)
        ? Object.keys(p.variations[0] || {})
        : Object.keys(p.variations || {});
      keys.forEach((k) => uniq.add(k));
    });
    setOptions(Array.from(uniq));
  }, [initial.allProducts]);

  const minPercent = useMemo(
    () => ((minPrice - rangeMin) * 100) / (rangeMax - rangeMin),
    [minPrice]
  );
  const maxPercent = useMemo(
    () => ((maxPrice - rangeMin) * 100) / (rangeMax - rangeMin),
    [maxPrice]
  );
  const trackBackground = `
    linear-gradient(
      to right,
      #ccc 0%,
      #ccc ${minPercent}%,
      #c61218 ${minPercent}%,
      #c61218 ${maxPercent}%,
      #ccc ${maxPercent}%,
      #ccc 100%
    )
  `;

  const toggleVar = (v) =>
    setSelected((prev) =>
      prev.includes(v) ? prev.filter((x) => x !== v) : [...prev, v]
    );

  const apply = () => {
    onChange({ minPrice, maxPrice, variations: selected });
  };

  return (
    <aside className="FilterSidebar">
      <h3>Precio</h3>
      <div className="FilterSidebar__range">
        <div className="slider-outer">
          <input
            type="range"
            min={rangeMin}
            max={rangeMax}
            value={minPrice}
            onChange={(e) =>
              setMinPrice(Math.min(+e.target.value, maxPrice))
            }
            style={{ background: trackBackground }}
          />
          <input
            type="range"
            min={rangeMin}
            max={rangeMax}
            value={maxPrice}
            onChange={(e) =>
              setMaxPrice(Math.max(+e.target.value, minPrice))
            }
            style={{ background: trackBackground }}
          />
          <div className="slider-labels">
            <span style={{ left: `${minPercent}%` }}>
              {currencyFormatter.format(minPrice)}
            </span>
            <span style={{ left: `${maxPercent}%` }}>
              {currencyFormatter.format(maxPrice)}
            </span>
          </div>
        </div>
      </div>

      <h3>Variaciones</h3>
      <div className="FilterSidebar__options">
        {options.map((opt) => (
          <label key={opt}>
            <input
              type="checkbox"
              checked={selected.includes(opt)}
              onChange={() => toggleVar(opt)}
            />
            <span>{opt}</span>
          </label>
        ))}
      </div>

      <button className="btn btn-apply" onClick={apply}>
        APLICAR FILTROS
      </button>
    </aside>
  );
};

export default FilterSidebar;
